import React, { Component } from "react";
import withErrorHandler from "../../../hoc/withErrorHandler";
import Axios from "../../../config/axios";
import {
  Row,
  Table,
  Tooltip,
  Button,
  Modal,
  Skeleton,
  Col,
  Divider,
} from "antd";
import searchColumns from "../../../helpers/searchColumns";
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import TextArea from "antd/lib/input/TextArea";
import { suratKehilangan } from "config/lettersId";
import { suratKeterlambatanPembayaran } from "config/lettersId";
import { suratMagang } from "config/lettersId";
import { suratPKL } from "config/lettersId";
import { displayDate } from "../../../helpers/displayDate";

const moment = require("moment");

class IncomingLetters extends Component {
  state = {
    letters: [],
    page: 1,
    pageSize: 20,
    pagination: {},
    searchText: "",
    searchedColumn: "",
    totalLetter: 0,
    rejectModal: false,
    rejectionReason: "",
    selectedRow: {},
    student: {},
    history: [],
    studentModal: false,
    studentLoading: false,
    historyLoading: false,
    detailModal: false,
    detailLoading: false,
    detailLetter: [],
    detailLetterType: {
      letter_id: "",
      lost_letter: "",
      late_letter: "",
      late_letter_file: "",
      internship_type: "",
    },
    letterFields: [],
    unit: "",
    dopingDoji: [],
    internshipMember: [],
    isReadOnly: false,
  };

  componentDidMount() {
    this.checkUnit();
    this.setState({ isReadOnly: this.props.user.info.type === "guest" });
  }

  checkUnit = () => {
    this.setState({ unit: this.props.user.info.unit_id }, () =>
      this.fetchLetters()
    );
  };

  fetchLetters = (filters = {}, sorter = {}) => {
    let params = {};
    // if(filters.letters_type) params.letters_type = filters.letters_type[0]
    if (filters.requester) params.requester = filters.requester[0];
    if (sorter.field && sorter.order) {
      params.sort_field = sorter.field;
      params.sort_order = sorter.order === "ascend" ? 1 : -1;
    }

    if (this.props.user.info.type === "operator") {
      params.faculty_id = this.state.unit;
    }

    if (this.props.user.info.type === "prodi") {
      params.major_id = this.state.unit;
    }

    Axios.get("/requested-letters", {
      params: {
        page: this.state.page,
        step: "submitted",
        page_size: this.state.pageSize,
        ...params,
      },
    }).then((response) => {
      let { pagination } = this.state;
      pagination.total = response.data.total;
      pagination.pageSize = this.state.pageSize;
      this.props.countLetters(response.data.total, "incoming");
      this.setState(
        {
          letters: response.data.payload,
          pagination,
          totalLetter: response.data.total,
        },
        this.getUnits
      );
    });
  };

  getUnits = async () => {
    const letters = this.state.letters.map((letter) => {
      return Axios.get(
        `/units?unit_id=${letter.faculty_id}&major_id=${letter.major_id}`
      )
        .then((response) => {
          return {
            ...letter,
            major: response.data.payload.name,
          };
        })
        .catch((e) => {
          console.error(e);
          return letter;
        });
    });

    Promise.all(letters).then((response) => {
      this.setState({ letters: response });
    });
  };

  fetchHistory = (requester) => {
    this.setState({ historyLoading: true });
    Axios.get("/requested-letters?requester=" + requester)
      .then((response) => {
        this.setState({
          history: response.data.payload,
          historyLoading: false,
        });
      })
      .catch(() => {
        this.setState({ historyLoading: false });
      });
  };

  handleChangeTable = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState(
      {
        pagination: pager,
        page: pager.current,
      },
      () => {
        this.fetchLetters(filters, sorter);
      }
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handleConfirmLetter = (record) => {
    Modal.confirm({
      title: "Proses Surat",
      content: "Apakah Anda yakin untuk memeroses surat ini?",
      icon: <ExclamationCircleOutlined />,
      okText: "Ya",
      cancelText: "Tidak",
      onOk: () => this.handleAcceptLetter(record),
      oncancel: {},
    });
  };

  handleAcceptLetter = (record) => {
    record.step = "processed";
    record.processed_date = "1";
    const value = (record.fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const responseValue = (record.response_fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const dopingDoji = (record.doping_doji || []).map((field) =>
      JSON.stringify(field)
    );
    const internshipMember = record.internship_member
      ? record.internship_member.map((field) => JSON.stringify(field))
      : [];
    Promise.all([value, responseValue, dopingDoji, internshipMember]).then(
      (result) => {
        record.fields_value = result[0];
        record.addressed = JSON.stringify(record.addressed);
        record.thesis_detail = JSON.stringify(record.thesis_detail);
        record.response_fields_value = result[1];
        record.doping_doji = result[2];
        record.internship_member = result[3];
        Axios.put("/requested-letters/save/" + record._id, record)
          .then(() => {
            this.fetchLetters();
          })
          .catch((error) => {
            console.error(error.data);
          });
      }
    );
  };

  onRejectLetter = () => {
    let record = this.state.selectedRow;
    record.rejected_date = "1";
    record.rejected_reason = this.state.rejectionReason;
    record.step = "rejected";
    const value = (record.fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const responseValue = (record.response_fields_value || []).map((field) =>
      JSON.stringify(field)
    );
    const dopingDoji = (record.doping_doji || []).map((field) =>
      JSON.stringify(field)
    );
    const internshipMember = record.internship_member
      ? record.internship_member.map((field) => JSON.stringify(field))
      : [];
    Promise.all([value, responseValue, dopingDoji, internshipMember]).then(
      (result) => {
        record.fields_value = result[0];
        record.response_fields_value = result[1];
        record.doping_doji = result[2];
        record.internship_member = result[3];
        record.addressed = JSON.stringify(record.addressed);
        record.thesis_detail = JSON.stringify(record.thesis_detail);
        Axios.put("/requested-letters/save/" + record._id, record).then(() => {
          this.fetchLetters();
        });
      }
    );
    this.setState({ rejectModal: false });
  };

  handleRejectLetter = (record) => {
    this.setState({ rejectModal: true, selectedRow: record });
  };

  handleChangeRejection = (e) => {
    this.setState({ rejectionReason: e.target.value });
  };

  toggleStudentModal = () => {
    this.setState({ studentModal: !this.state.studentModal });
  };

  toggleDetailModal = () => {
    this.setState({ detailModal: !this.state.detailModal });
  };

  fetchStudent = (nim) => {
    this.toggleStudentModal();
    this.setState({ studentLoading: true });
    this.fetchHistory(nim);

    Axios.get("/users/mahasiswa/" + nim)
      .then((response) => {
        this.setState({ student: response.data, studentLoading: false });
      })
      .catch(() => {
        this.toggleStudentModal();
        this.setState({ studentLoading: false });
      });
  };

  fetchDetail = (record) => {
    this.toggleDetailModal();
    this.setState({
      detailLoading: true,
      letterFields: record.fields,
      dopingDoji: record.doping_doji || [],
    });

    Axios.get("/requested-letters/" + record._id)
      .then((response) => {
        const res = displayDate(response.data.fields, response.data);
        this.setState({
          detailLetter: res.fields_value,
          detailLetterType: {
            letter_id: res.letters_id,
            lost_letter: res.lost_letter_type,
            late_letter_file: res.additional_late_payment_value,
            late_letter: res.additional_late_payment_value2,
            internship_type: res.internship_type,
          },
          detailLoading: false,
          internshipMember: res.internship_member,
        });
      })
      .catch(() => {
        this.toggleDetailModal();
        this.setState({ detailLoading: false });
      });
  };

  handleFileClick = (file) => {
    window.open(file, "_blank");
  };

  render() {
    const columns = [
      {
        title: "NIM",
        dataIndex: "requester",
        sorter: true,
        ...searchColumns(
          "requester",
          this.handleSearch,
          this.handleReset,
          this.state.searchedColumn,
          this.state.searchText
        ),
        render: (text) => (
          <Tooltip title="Biodata Mahasiswa">
            <Button type="link" onClick={() => this.fetchStudent(text)}>
              {text}
            </Button>
          </Tooltip>
        ),
      },
      {
        title: "Prodi",
        dataIndex: "major",
        sorter: true,
        render: (text) => text || <LoadingOutlined />,
      },
      {
        title: "Jenis Surat",
        sorter: true,
        render: (record) => (
          <Tooltip title="Detail Pemohonan">
            <Button type="link" onClick={() => this.fetchDetail(record)}>
              {record.letters_name}
            </Button>
          </Tooltip>
        ),
        // ...searchColumns('', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      // {
      //     title: 'Tipe Surat',
      //     dataIndex: 'letters_type',
      //     sorter: true,
      //     filters:  [
      //         { text: 'Akademik', value: 'akademik' },
      //         { text: 'Kemahasiswaan', value: 'kemahasiswaan' },
      //     ],
      //     filterMultiple: false,
      //     render: type => {
      //         const colors = {
      //             akademik : 'blue',
      //             kemahasiswaan : 'green',
      //         }
      //         return <Tag color={colors[type]}>{type.toUpperCase()}</Tag>
      //     }
      // } ,
      {
        title: "Tanggal Masuk",
        dataIndex: "submitted_date",
        sorter: true,
        render: (text) => (text ? moment(text).format("LLL") : "-"),
        // ...searchColumns('requester', this.handleSearch, this.handleReset, this.state.searchedColumn, this.state.searchText)
      },
      {
        title: "",
        render: (record) =>
          !this.state.isReadOnly ? (
            <>
              <Tooltip title="Proses" className="m-2">
                <Button
                  shape="circle"
                  className="add-button"
                  onClick={() => this.handleConfirmLetter(record)}
                >
                  <CheckOutlined />
                </Button>
              </Tooltip>
              <Tooltip title="Tolak" className="m-2">
                <Button
                  shape="circle"
                  type="danger"
                  onClick={() => this.handleRejectLetter(record)}
                >
                  <CloseOutlined />
                </Button>
              </Tooltip>
            </>
          ) : (
            <></>
          ),
      },
    ];

    return (
      <>
        <Row style={{ padding: 10 }}>
          <Table
            rowKey="_id"
            style={{ width: "100%" }}
            columns={columns}
            dataSource={this.state.letters}
            loading={this.props.loading}
            pagination={this.state.pagination}
            onChange={this.handleChangeTable}
          />
        </Row>

        <Modal
          title="Tolak Permohonan"
          visible={this.state.rejectModal}
          okText="Ya"
          cancelText="Tidak"
          onOk={this.onRejectLetter}
          onCancel={() => this.setState({ rejectModal: false })}
        >
          <label>Alasan Penolakan</label>
          <TextArea
            onChange={this.handleChangeRejection}
            value={this.state.rejectionReason}
            placeholder="Masukkan Alasan Penolakan"
          />
        </Modal>

        <Modal
          title="Biodata Mahasiswa"
          visible={this.state.studentModal}
          footer={null}
          onCancel={this.toggleStudentModal}
        >
          <Skeleton active={true} loading={this.state.studentLoading}>
            <Row>
              <Col span={6} className="mr-1">
                <img
                  alt=""
                  src={this.state.student["FOTO"]}
                  style={{ objectFit: "cover", width: "100%" }}
                />
              </Col>
              <Col>
                <table>
                  <tbody>
                    <tr>
                      <td>Nama</td>
                      <td>: {this.state.student["nama"]}</td>
                    </tr>
                    <tr>
                      <td>NIM</td>
                      <td>: {this.state.student["nim"]}</td>
                    </tr>
                    <tr>
                      <td>Angkatan</td>
                      <td>: {this.state.student["angkatan"]}</td>
                    </tr>
                    <tr>
                      <td>Program Studi</td>
                      <td>: {this.state.student["program_studi"]}</td>
                    </tr>
                    <tr>
                      <td>Tempat Lahir</td>
                      <td>: {this.state.student["tempat_lahir"]}</td>
                    </tr>
                    <tr>
                      <td>Tanggal Lahir</td>
                      <td>
                        :{" "}
                        {moment(this.state.student["tanggal_lahir"]).format(
                          "ll"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>No. HP</td>
                      <td>: {this.state.student["no_hp_mahasiswa"]}</td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td>: {this.state.student["email"]}</td>
                    </tr>
                  </tbody>
                </table>
              </Col>
            </Row>
          </Skeleton>
          <Col className="mt-2">
            <h3>Riwayat Permohonan</h3>
            <Col>
              <Table
                rowKey="_id"
                dataSource={this.state.history}
                columns={[
                  {
                    title: "Tanggal Mengajukan",
                    dataIndex: "submitted_date",
                    render: (text) => moment(text).format("lll"),
                  },
                  {
                    title: "Jenis Surat",
                    dataIndex: "letters_name",
                  },
                  {
                    title: "Status",
                    dataIndex: "step",
                    render: (text) => {
                      const label = {
                        submitted: "DIAJUKAN",
                        processed: "DIPROSES",
                        finished: "SELESAI",
                        rejected: "DITOLAK",
                      };
                      return label[text] || "";
                    },
                  },
                ]}
                pagination={{
                  pageSize: 4,
                }}
              />
            </Col>
          </Col>
        </Modal>

        <Modal
          title="Detail Permohonan"
          footer={null}
          onCancel={this.toggleDetailModal}
          visible={this.state.detailModal}
        >
          <Skeleton active={true} loading={this.state.detailLoading}>
            {this.state.letterFields.map((field, index) => {
              const value = this.state.detailLetter.find(
                (detail) => detail.field_id === field._id
              );
              return (
                <div key={index}>
                  <div>
                    <strong>{field.label}</strong>
                  </div>
                  <Skeleton
                    active={true}
                    paragraph={0}
                    loading={value ? false : true}
                  >
                    {value ? (
                      ["text", "textarea"].includes(field.field_type) ? (
                        value.value
                      ) : (
                        <Button
                          size="small"
                          onClick={() => this.handleFileClick(value.value)}
                        >
                          <DownloadOutlined /> Unduh
                        </Button>
                      )
                    ) : (
                      ""
                    )}
                    <div></div>
                  </Skeleton>
                  <Divider type="horizontal" style={{ marginTop: 10 }} />
                </div>
              );
            })}
            {this.state.dopingDoji.map((field, index) => {
              return (
                <div key={index}>
                  <div>
                    <strong>{field.type}</strong>
                  </div>
                  <Skeleton
                    active={true}
                    paragraph={0}
                    loading={this.state.dopingDoji ? false : true}
                  >
                    {field.name}
                  </Skeleton>
                  <Divider type="horizontal" style={{ marginTop: 10 }} />
                </div>
              );
            })}
            {this.state.detailLetterType.letter_id === suratKehilangan ? (
              <div>
                <div>
                  <strong>Kehilangan</strong>
                </div>
                <Skeleton
                  active={true}
                  paragraph={0}
                  loading={this.state.detailLetterType.letter_id ? false : true}
                >
                  {this.state.detailLetterType.lost_letter}
                </Skeleton>
                <Divider type="horizontal" style={{ marginTop: 10 }} />
              </div>
            ) : null}
            {this.state.detailLetterType.letter_id ===
            suratKeterlambatanPembayaran ? (
              <>
                <div>
                  <div>
                    <strong>Jenis Keterlambatan</strong>
                  </div>
                  <Skeleton
                    active={true}
                    paragraph={0}
                    loading={
                      this.state.detailLetterType.letter_id ? false : true
                    }
                  >
                    {this.state.detailLetterType.late_letter}
                  </Skeleton>
                  <Divider type="horizontal" style={{ marginTop: 10 }} />
                </div>
                <div>
                  <div>
                    <strong>Cover ACC Sidang Meja Hijau</strong>
                  </div>
                  <Skeleton
                    active={true}
                    paragraph={0}
                    loading={
                      this.state.detailLetterType.letter_id ? false : true
                    }
                  >
                    <Button
                      size="small"
                      onClick={() =>
                        this.handleFileClick(
                          this.state.detailLetterType.late_letter_file
                        )
                      }
                    >
                      <DownloadOutlined /> Unduh
                    </Button>
                  </Skeleton>
                  <Divider type="horizontal" style={{ marginTop: 10 }} />
                </div>
              </>
            ) : null}
            {[suratPKL, suratMagang].includes(
              this.state.detailLetterType.letter_id
            ) ? (
              <div>
                <div>
                  <strong>Jenis Magang/PKL</strong>
                </div>
                <Skeleton
                  active={true}
                  paragraph={0}
                  loading={this.state.detailLetterType.letter_id ? false : true}
                >
                  {this.state.detailLetterType.internship_type}
                </Skeleton>
                <Divider type="horizontal" style={{ marginTop: 10 }} />
              </div>
            ) : null}
            {[suratPKL, suratMagang].includes(
              this.state.detailLetterType.letter_id
            ) && this.state.detailLetterType.internship_type === "kelompok" ? (
              <div>
                <div>
                  <strong>Anggota Kelompok</strong>
                </div>
                <Skeleton
                  active={true}
                  paragraph={0}
                  loading={this.state.internshipMember ? false : true}
                >
                  <table>
                    <tr>
                      <th>NIM</th>
                      <th>Nama</th>
                    </tr>
                    {this.state.internshipMember.map((member, index) => (
                      <tr key={index}>
                        <td style={{ padding: 5 }}>{member.name}</td>
                        <td>{member.nim}</td>
                      </tr>
                    ))}
                  </table>
                </Skeleton>
                <Divider type="horizontal" style={{ marginTop: 10 }} />
              </div>
            ) : null}
          </Skeleton>
        </Modal>
      </>
    );
  }
}

export default withErrorHandler(IncomingLetters, Axios);
